// Will not mutate input array, but the unchanged elements are shallow copies pointing to same memory location as elements of input array

const replaceOneElementInArray = <A extends any[]>(
  array: [...A],
  index: number,
  newValue: A[keyof A]
): A => [...array.slice(0, index), newValue, ...array.slice(index + 1)] as A;

export { replaceOneElementInArray };
